import styled from 'styled-components';

export const SkillsContainer = styled.div`
  height: 100vh;
  width: 100vw;
  background: ${(props) => props.theme.skillsBackground};
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`;

export const SkillsTabContainer = styled.div`
  background: ${(props) => props.theme.skillsAccordionBackground};
  width: 70vw;
  border-left: 1px solid ${(props) => props.theme.skillsMainBorderColor};
  border-right: 1px solid ${(props) => props.theme.skillsMainBorderColor};
  border-bottom: 1px solid ${(props) => props.theme.skillsMainBorderColor};

  @media (max-width: 710px) {
    width: 100vw;
  }
`;

export const SkillsWidgetsContainer = styled.div`
  background: #ffffff;
  display: flex;
  flex-direction: column;
  width: 30vw;
  height: 100vh;
  border-left: 1px solid ${(props) => props.theme.skillsMainBorderColor};
  border-right: 1px solid ${(props) => props.theme.skillsMainBorderColor};
  border-bottom: 1px solid ${(props) => props.theme.skillsMainBorderColor};

  p {
    font-size: 14px;
  }

  @media (max-width: 710px) {
    height: 100%;
  }
`;
